import React from "react";
import { signIn } from "../reducks/users/operations";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import { useEffect } from "react";
import { signOutUser } from "../reducks/users/operations";
import { getSignedIn } from "../reducks/users/selectors";
const DefaultEntrance = () => {
  const dispatch = useDispatch();
  const isSignedIn = useSelector(getSignedIn);
  useEffect(() => {
    if (!isSignedIn) dispatch(signOutUser());
    dispatch(signIn("connection@morimatsu.jp", "123456"));
  }, []);

  return <></>;
};
export default DefaultEntrance;
